import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Button } from '../../../components/button'
import { InputWrapper } from '../../../components/input/input.style'
import { Textarea } from '../../../components/textarea/textarea'
import { SelectInput } from '../../../components/select/select';

//Registration schema
const schema = yup.object().shape({
    subject: yup.string().required("Subject is a required field"),
    description: yup.string().required("Description is a required field"),
});

const AnnouncementCreate = () => {
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];

    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Announcements
                        </Heading>
                        <Breadcrumb
                            crumbs={['Announcements', 'MAKE ANNOUNCEMENT']}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="subject"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="subject"
                                                type="text"
                                                placeholder="Subject Title"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.subject?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Textarea
                                    id="announcementDescription"
                                    label="ANNOUNCEMENT"
                                    type="text"
                                    placeholder="Hello World!"
                                    {...register("description")}
                                    error={errors.description?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                SHARE
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default AnnouncementCreate
